// DS9.4.2, DS9.4.2M
import React from 'react';
import { useTranslation } from 'react-i18next';
import PollView from '../../../PollView';
import { FeedCardProps } from '../types';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';

import optionStyles from './PollOption.scss';
import s from './Poll.scss';

const PollFeedCardContents: React.FC<FeedCardProps> = ({
  className,
  deviation,
  extraActions,
  withWatchOrSubscribeButton,
}) => {
  const { t } = useTranslation();

  return (
    <FeedCardLayout
      className={className}
      deviation={deviation}
      extraActions={extraActions}
      withWatchOrSubscribeButton={withWatchOrSubscribeButton}
      withCommentControl
    >
      <FeedCardTitle
        className={s['title']}
        deviation={deviation}
        disableScrollRestoration={false}
      />

      <div className={s['vote-count']}>{t('pollView.votes', { count: deviation.poll?.votes })}</div>

      {/* TODO: lose this and bring in PollOption, canVote, and onVote */}
      <PollView
        deviation={deviation}
        hideQuestion
        stylesheet={s as any}
        optionImageSize={32}
        optionHoverImageSize={192}
        optionStylesheet={optionStyles as any}
      />
    </FeedCardLayout>
  );
};
PollFeedCardContents.displayName = 'PollFeedCardContents';
export default PollFeedCardContents;
